/**
 * @fileoverview gRPC-Web generated client stub for assetpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: assetpb/securitymaster.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_field_mask_pb = require('google-protobuf/google/protobuf/field_mask_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_type_date_pb = require('../google/type/date_pb.js')

var utilspb_pagination_pb = require('../utilspb/pagination_pb.js')
const proto = {};
proto.assetpb = require('./securitymaster_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.assetpb.SecurityMasterServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.assetpb.SecurityMasterServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.assetpb.ListSecurityMasterRequest,
 *   !proto.assetpb.ListSecurityMasterResponse>}
 */
const methodDescriptor_SecurityMasterService_ListSecurityMaster = new grpc.web.MethodDescriptor(
  '/assetpb.SecurityMasterService/ListSecurityMaster',
  grpc.web.MethodType.UNARY,
  proto.assetpb.ListSecurityMasterRequest,
  proto.assetpb.ListSecurityMasterResponse,
  /**
   * @param {!proto.assetpb.ListSecurityMasterRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.assetpb.ListSecurityMasterResponse.deserializeBinary
);


/**
 * @param {!proto.assetpb.ListSecurityMasterRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.assetpb.ListSecurityMasterResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.assetpb.ListSecurityMasterResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.assetpb.SecurityMasterServiceClient.prototype.listSecurityMaster =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/assetpb.SecurityMasterService/ListSecurityMaster',
      request,
      metadata || {},
      methodDescriptor_SecurityMasterService_ListSecurityMaster,
      callback);
};


/**
 * @param {!proto.assetpb.ListSecurityMasterRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.assetpb.ListSecurityMasterResponse>}
 *     Promise that resolves to the response
 */
proto.assetpb.SecurityMasterServicePromiseClient.prototype.listSecurityMaster =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/assetpb.SecurityMasterService/ListSecurityMaster',
      request,
      metadata || {},
      methodDescriptor_SecurityMasterService_ListSecurityMaster);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.assetpb.ListSecurityMasterMultipleRequest,
 *   !proto.assetpb.ListSecurityMasterMultipleResponse>}
 */
const methodDescriptor_SecurityMasterService_ListSecurityMasterMultiple = new grpc.web.MethodDescriptor(
  '/assetpb.SecurityMasterService/ListSecurityMasterMultiple',
  grpc.web.MethodType.UNARY,
  proto.assetpb.ListSecurityMasterMultipleRequest,
  proto.assetpb.ListSecurityMasterMultipleResponse,
  /**
   * @param {!proto.assetpb.ListSecurityMasterMultipleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.assetpb.ListSecurityMasterMultipleResponse.deserializeBinary
);


/**
 * @param {!proto.assetpb.ListSecurityMasterMultipleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.assetpb.ListSecurityMasterMultipleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.assetpb.ListSecurityMasterMultipleResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.assetpb.SecurityMasterServiceClient.prototype.listSecurityMasterMultiple =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/assetpb.SecurityMasterService/ListSecurityMasterMultiple',
      request,
      metadata || {},
      methodDescriptor_SecurityMasterService_ListSecurityMasterMultiple,
      callback);
};


/**
 * @param {!proto.assetpb.ListSecurityMasterMultipleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.assetpb.ListSecurityMasterMultipleResponse>}
 *     Promise that resolves to the response
 */
proto.assetpb.SecurityMasterServicePromiseClient.prototype.listSecurityMasterMultiple =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/assetpb.SecurityMasterService/ListSecurityMasterMultiple',
      request,
      metadata || {},
      methodDescriptor_SecurityMasterService_ListSecurityMasterMultiple);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.assetpb.CreateSecurityMasterRequest,
 *   !proto.assetpb.CreateSecurityMasterResponse>}
 */
const methodDescriptor_SecurityMasterService_CreateSecurityMaster = new grpc.web.MethodDescriptor(
  '/assetpb.SecurityMasterService/CreateSecurityMaster',
  grpc.web.MethodType.UNARY,
  proto.assetpb.CreateSecurityMasterRequest,
  proto.assetpb.CreateSecurityMasterResponse,
  /**
   * @param {!proto.assetpb.CreateSecurityMasterRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.assetpb.CreateSecurityMasterResponse.deserializeBinary
);


/**
 * @param {!proto.assetpb.CreateSecurityMasterRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.assetpb.CreateSecurityMasterResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.assetpb.CreateSecurityMasterResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.assetpb.SecurityMasterServiceClient.prototype.createSecurityMaster =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/assetpb.SecurityMasterService/CreateSecurityMaster',
      request,
      metadata || {},
      methodDescriptor_SecurityMasterService_CreateSecurityMaster,
      callback);
};


/**
 * @param {!proto.assetpb.CreateSecurityMasterRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.assetpb.CreateSecurityMasterResponse>}
 *     Promise that resolves to the response
 */
proto.assetpb.SecurityMasterServicePromiseClient.prototype.createSecurityMaster =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/assetpb.SecurityMasterService/CreateSecurityMaster',
      request,
      metadata || {},
      methodDescriptor_SecurityMasterService_CreateSecurityMaster);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.assetpb.UpdateSecurityMasterRequest,
 *   !proto.assetpb.UpdateSecurityMasterResponse>}
 */
const methodDescriptor_SecurityMasterService_UpdateSecurityMaster = new grpc.web.MethodDescriptor(
  '/assetpb.SecurityMasterService/UpdateSecurityMaster',
  grpc.web.MethodType.UNARY,
  proto.assetpb.UpdateSecurityMasterRequest,
  proto.assetpb.UpdateSecurityMasterResponse,
  /**
   * @param {!proto.assetpb.UpdateSecurityMasterRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.assetpb.UpdateSecurityMasterResponse.deserializeBinary
);


/**
 * @param {!proto.assetpb.UpdateSecurityMasterRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.assetpb.UpdateSecurityMasterResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.assetpb.UpdateSecurityMasterResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.assetpb.SecurityMasterServiceClient.prototype.updateSecurityMaster =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/assetpb.SecurityMasterService/UpdateSecurityMaster',
      request,
      metadata || {},
      methodDescriptor_SecurityMasterService_UpdateSecurityMaster,
      callback);
};


/**
 * @param {!proto.assetpb.UpdateSecurityMasterRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.assetpb.UpdateSecurityMasterResponse>}
 *     Promise that resolves to the response
 */
proto.assetpb.SecurityMasterServicePromiseClient.prototype.updateSecurityMaster =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/assetpb.SecurityMasterService/UpdateSecurityMaster',
      request,
      metadata || {},
      methodDescriptor_SecurityMasterService_UpdateSecurityMaster);
};


module.exports = proto.assetpb;

